import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { $dmSansFontFamily, colorsPalettes, setFontVariant } from "@similarweb/styles";

import ChipItemsContainer from "./ChipItemsContainer/ChipItemsContainer";

export const StyledFilterSuggestionsBar = styled.div`
    background-color: ${colorsPalettes.bluegrey[200]};
    padding: 8px 12px;
    border-radius: 8px;
    margin-bottom: 16px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
`;

export const StyledSuggestedChipsContainer = styled(ChipItemsContainer)`
    margin-top: 8px;
    width: 100%;
`;

export const StyledSuggestIcon = styled(SWReactIcons)`
    path {
        fill: ${colorsPalettes.carbon[300]};
    }
`;

export const StyledFilterSuggestionsTitle = styled.span`
    ${setFontVariant("caption", colorsPalettes.carbon[300])}
    font-family: ${$dmSansFontFamily};
    line-height: 20px;
    margin-left: 3px;
`;

export const StyledSuggestedWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const StyledLoaderWrapper = styled.div`
    display: flex;
    justify-content: center;
    width: 85px;
`;
